import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./msg-preview.module.scss";
import classnames from "classnames";
import { useClickOutside } from "@whatslly/ui-components/componentsUtils";

export const MsgPreview: React.FC<{ previewMsg?: string; onClose: VoidFunction }> = ({ previewMsg, onClose }) => {
  const { t } = useTranslation();
  const ref = useClickOutside<HTMLDivElement>({ callback: onClose, activate: true });
  return (
    <div ref={ref} className={classnames(styles.previewV2)}>
      <h3>{t("helpers_template_preview")}</h3>
      <div className={styles.message}>
        <svg viewBox="0 0 8 13" width="8" height="13">
          <path opacity=".13" d="M5.188 1H0v11.193l6.467-8.625C7.526 2.156 6.958 1 5.188 1z"></path>
          <path fill="currentColor" d="M5.188 0H0v11.193l6.467-8.625C7.526 1.156 6.958 0 5.188 0z"></path>
        </svg>
        {previewMsg}
      </div>
    </div>
  );
};
